import {
  takeLatest, put, call,
} from 'redux-saga/effects';
import api from 'store/api';
import { toast } from 'react-toastify';
import { URL } from '../../../constants/url';
import actionTypes from '../actionTypes';
import { upgradeCost as upgradeCostActions } from '../actions';

export function* upgradeCost({ payload }) {
  try {
    const res = yield call(api, {
      method: 'post',
      url: URL.UPGRADE_COST,
      data: { priceId: payload },
    });
    yield put(upgradeCostActions.success(res?.data));
  } catch (e) {
    yield call(toast.error, e.message);
    yield put(upgradeCostActions.error(e.message));
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.UPGRADE_COST, upgradeCost);
}
